/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const BluetoothMusic = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 25 22" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M16.51 7.75a.42.42 0 0 0 0 .6 3.23 3.23 0 0 1 0 4.55.42.42 0 0 0 0 .6.41.41 0 0 0 .6 0 4.08 4.08 0 0 0 0-5.75.43.43 0 0 0-.6 0zM19.17 6.74a.39.39 0 0 0 0 .56 4.71 4.71 0 0 1 0 6.65.39.39 0 0 0 0 .56.38.38 0 0 0 .28.12.39.39 0 0 0 .28-.12 5.5 5.5 0 0 0 0-7.77.4.4 0 0 0-.56 0z" /><path d="M22.28 5.14a.43.43 0 0 0-.736.3.42.42 0 0 0 .126.3 6.92 6.92 0 0 1 0 9.77.43.43 0 0 0 0 .61.42.42 0 0 0 .3.12.47.47 0 0 0 .31-.12 7.79 7.79 0 0 0 0-10.98zM15.64 6.18a.89.89 0 0 0-.41-.77l-8-5.26a.91.91 0 0 0-1.41.76v7.87l-4-2.52a.92.92 0 0 0-1.26.28.91.91 0 0 0 .29 1.25l4.8 3-4.8 3a.918.918 0 1 0 1 1.54l4-2.52v7.87a.91.91 0 0 0 1.41.76l8-5.26a.89.89 0 0 0 .41-.77.91.91 0 0 0-.42-.76l-6.16-3.88 6.16-3.89a.91.91 0 0 0 .39-.7zm-2.58 9.32l-5.43 3.56v-7l5.43 3.44zM7.63 9.58v-7l5.43 3.56-5.43 3.44z" /></g>
      </g>
    </svg>
  </span>
);

BluetoothMusic.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

BluetoothMusic.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default BluetoothMusic;
